import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DrawerService } from '../../services/drawer.service';
import { AppBarComponent } from '../app-bar/app-bar.component';
import { DrawerContainerComponent } from '../drawer/drawer-container/drawer-container.component';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
  imports: [
    RouterModule,
    SidebarComponent,
    HeaderComponent,
    AppBarComponent,
    DrawerContainerComponent,
  ],
  selector: 'siat-layout',

  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent {
  /**
   * Injections
   */
  drawerService = inject(DrawerService);

  /**
   * The current state of the sidebar.
   */
  isSidebarCollapsed = true;

  /**
   * On sidebar toggled event.
   */
  onSidebarToggled(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  /**
   * Handles backdrop click
   */
  onBackdropClick(): void {
    const config = this.drawerService.config();
    if (!config.disableClose) {
      this.drawerService.close();
    }
  }
}
